var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRestore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 50,
    viewBox: "0 0 52 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.1545 21.4298H49.103C50.5871 21.4298 51.7812 20.2358 51.7812 18.7516V4.46794C51.7812 3.3855 51.1339 2.4035 50.1296 1.99061C49.1253 1.57772 47.9759 1.80091 47.2059 2.57089L42.5637 7.21309C32.7883 -2.43956 17.0428 -2.40609 7.32318 7.32468C-2.44106 17.0889 -2.44106 32.9126 7.32318 42.6768C17.0874 52.4411 32.9111 52.4411 42.6753 42.6768C44.0702 41.2819 44.0702 39.0166 42.6753 37.6217C41.2804 36.2268 39.0151 36.2268 37.6202 37.6217C30.6458 44.5962 19.3416 44.5962 12.3671 37.6217C5.39265 30.6473 5.39265 19.3431 12.3671 12.3686C19.3081 5.42763 30.523 5.39415 37.5086 12.257L32.9222 16.8546C32.1523 17.6246 31.9291 18.774 32.342 19.7783C32.7548 20.7826 33.7369 21.4298 34.8193 21.4298H48.1545Z",
    fill: "#303A46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestore);
export default __webpack_public_path__ + "static/media/restore.ef47396b001dbd397a4739b79be05805.svg";
export { ForwardRef as ReactComponent };